import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import cx from 'clsx';
import type React from 'react';
import { Fragment } from 'react';
import { IDown } from 'ui/component/Icons.tsx';
import { Spinner } from 'ui/component/Spinner.tsx';
import { useDateFormat } from '../hook/useDateFormat.ts';

export const DateFormatSelector: React.FC = () => {
  const { currentDateFormat, dateFormats, updateDateFormat, isLoading, isUpdatingUser } = useDateFormat();

  return (
    <>
      <Popover className="relative">
        <PopoverButton
          disabled={isLoading || isUpdatingUser}
          className="group flex w-full items-center justify-between border border-grey-border px-3 py-2 text-left focus:border-blue focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
        >
          <span>{isLoading ? 'Loading...' : currentDateFormat}</span>
          <IDown className="ml-1 size-4 text-gray-400 transition duration-150 ease-in-out group-data-[headlessui-state~=open]:rotate-180" aria-hidden="true" />
        </PopoverButton>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <PopoverPanel className="absolute z-50 mt-1 w-full shadow-lg">
            {({ close }) => (
              <div className="relative flex flex-col bg-white shadow-lg outline-hidden">
                {dateFormats.map((format) => (
                  <button
                    key={format}
                    onClick={() => {
                      updateDateFormat(format);
                      close();
                    }}
                    className={cx('px-3 py-2 text-left text-sm', currentDateFormat === format ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100')}
                  >
                    {format}
                  </button>
                ))}
              </div>
            )}
          </PopoverPanel>
        </Transition>
      </Popover>
      {isUpdatingUser && <Spinner />}
    </>
  );
};
